import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { trpc } from "../../app/trpc.js";
import { buttonClass, Card, Notice, Spinner } from "../../ui/index.js";
import { fmtDateTime, useCabinet } from "../cabinet/index.js";
import { instagramLink } from "./status.js";

const small = "px-3 py-2 text-sm";

/**
 * Затронутые записи и как связаться с каждым клиентом: написать из кабинета (окно 7 дней после его последнего
 * сообщения ещё открыто), из приложения Instagram или позвонить.
 */
export function AffectedContacts({ bookingIds, onNavigate }: { bookingIds: string[]; onNavigate?: () => void }) {
  const { t, i18n } = useTranslation();
  const cab = useCabinet();
  const q = useQuery(trpc.cabinet.contacts.queryOptions({ salonId: cab.salonId, bookingIds: bookingIds.slice(0, 100) }));
  if (q.isPending) return <Spinner />;
  if (q.isError) return <Notice kind="error">{t("common.error")}</Notice>;
  return (
    <div className="space-y-2">
      {q.data.map((r) => (
        <Card key={r.booking.id}>
          <div className="text-sm text-slate-500">{fmtDateTime(r.booking.period.start, cab.timezone, i18n.language)}</div>
          <div className="font-medium">{r.client?.name || (r.client?.instagram ? `@${r.client.instagram}` : t("cal.noClient"))}</div>
          <div className="mt-2 flex flex-wrap gap-2">
            {r.conversationId && r.canWriteFromCabinet && (
              <Link to={`${cab.base}/conversations/${r.conversationId}`} onClick={onNavigate} className={buttonClass("primary", small)}>
                {t("cal.writeFromCabinet")}
              </Link>
            )}
            {r.client?.instagram && (
              <a href={instagramLink(r.client.instagram)} target="_blank" rel="noreferrer" className={buttonClass("secondary", small)}>
                Instagram
              </a>
            )}
            {r.client?.phone && (
              <a href={`tel:${r.client.phone}`} className={buttonClass("secondary", small)}>
                {t("cal.call")}
              </a>
            )}
          </div>
          {r.conversationId && !r.canWriteFromCabinet && <p className="mt-2 text-xs text-slate-500">{t("conv.windowClosed")}</p>}
          {!r.conversationId && !r.client?.instagram && !r.client?.phone && <p className="mt-2 text-xs text-slate-500">{t("cal.noContact")}</p>}
        </Card>
      ))}
    </div>
  );
}
